import { PLATFORMS } from '@/domains/core/settings/constants';
import { getPlatform } from '@/domains/core/settings/utils';

export const priceWithinKlarnaThresholds = (price: number) => {
  const MIN_KLARNA = {
    [PLATFORMS.GREAT_BRITAIN]: 35,
    [PLATFORMS.GERMANY]: 0.5,
    [PLATFORMS.FRANCE]: 80,
    [PLATFORMS.SPAIN]: 150,
    [PLATFORMS.ITALY]: 80,
  };

  const MAX_KLARNA = {
    [PLATFORMS.GREAT_BRITAIN]: 2500,
    [PLATFORMS.GERMANY]: 5000,
    [PLATFORMS.FRANCE]: 2000,
    [PLATFORMS.SPAIN]: 2000,
    [PLATFORMS.ITALY]: 1500,
  };

  const platform = getPlatform();
  return price >= MIN_KLARNA[platform] && price <= MAX_KLARNA[platform];
};
